import React, { useEffect, useMemo, useState } from 'react';
import { List, Empty, Tag, Button, Modal, Tooltip, Collapse } from 'antd';

import { createUseStyles } from 'react-jss'

import Icofont from 'react-icofont';

import uuid from 'react-uuid';
import { Action, errorCatch, GET, If, JSXMap, useAuth } from 'fennec-ui';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { getIndexColorLighter } from '../../../common/Tool';
import { useSelector } from 'react-redux';
import Nl2Br from '../../../common/Nl2br';
import Vozvrat from '../Vozvrat';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

var _ = require('lodash');

const useStyles = createUseStyles({
    selectPeople: {
        paddingBottom: "5px",
        '& .ant-input-prefix': {
            marginRight: "11px"
        },
        '& .ant-input-affix-wrapper': {
            padding: "4px 0px"
        }
    },
    listMeta: {
        '& .ant-list-item-meta-title': {
            marginBottom: "0"
        },
    },
    itemsListUsluga: {
        '& .ant-list .ant-list-item': {
            borderBottom: "1px solid #e1e1e1",
            alignItems: "flex-start"
        },
    },
    itemsOrderUsluga: {
        '& .ant-list-item': {
            alignItems: "flex-start"
        },
    },
    promo: {
        '& .ant-input-affix-wrapper': {
            paddingLeft: "0px",
        },
        '&': {
            borderBottom: "1px solid darkblue",
        },
        '&:hover': {
            borderBottom: "2px solid darkblue",
        },
    },
    appendButton: {
        '&.ant-btn': {
            width: "100%",
            backgroundColor: "#d9d9d9",
            boxShadow: "0px 1px 3px 0px rgba(141,141,141,0.74)",
            fontWeight: 600
        },
        '&.ant-btn:hover': {
            color: "#000",
            // background: #fff;
            boxShadow: "0px 2px 4px 0px rgba(141,141,141,0.74)",
            borderColor: "#d9d9d9",
        },
        '&.ant-btn:focus': {
            color: "#000",
            // background: #fff;
            boxShadow: "0px 2px 4px 0px rgba(141,141,141,0.74)",
            borderColor: "#d9d9d9",
        }
    }
})

const Header = ({ icon, title, style }) => {
    return (<span>
        <Icofont icon={icon} style={style} />
        <span>{title}</span>
    </span>);
};
const SingleHeader = () => {
    return (<Header icon="user-alt-3" title="Одиночный" style={{ color: "cadetblue", fontSize: "13px", paddingRight: "6px" }} />);
};
const FemaleHeader = () => {
    return (<Header icon="businesswoman" title="Женский" style={{ color: "red", fontSize: "16px", paddingRight: "6px" }} />);
};
const MaleHeader = () => {
    return (<Header icon="businessman" title="Мужской" style={{ color: "blue", fontSize: "16px", paddingRight: "6px" }} />);
};
const SelectCategory = (props) => {
    const { value } = props;
    if (!value || !value.kategoriya) {
        return (<></>);
    }
    return (<span>
        <span> - </span>
        <span style={{ fontStyle: "italic" }}>
            <a href="#">{_.get(value, "kategoriya.kategoriya.tantsevalnayaDistsiplina.nazvanie")} / {_.get(value, "kategoriya.kategoriya.kategoriyaUchastnikov.nazvanie")}</a>
        </span>
    </span>);
};
const SelectPeople = (props) => {
    const classes = useStyles();
    const { data, prefix, value } = props;
    const display = (object) => {
        if (object === undefined) {
            return <span>Укажите участника!</span>;
        }
        if (object) {
            if (object.polzovatelStrokoi) {
                return <span>{object.polzovatelStrokoi}</span>;
            }
            if (object.polzovatel) {
                return <span>{object.polzovatel.firstname + " " + object.polzovatel.lastname}</span>;
            }
            return <span>Укажите участника!</span>;
        }
        return <></>;
    };
    const triggerFunc = React.useMemo(() => (click) => (<Tag color={(value === undefined) ? "red" : ""} onClick={click}>
        {display(value)}
    </Tag>), [value]);
    // const filteredValue = (value && value.okazannieUslugiPolzovatelyamUchastik) ? value.okazannieUslugiPolzovatelyamUchastik.filter(i => i.uslugaKlientu.yacheikaUsluga.prilozhenieID) : undefined;
    return (<div className={classes.selectPeople}>
        <div>
            {prefix}
            <span style={{ paddingLeft: "10px" }}>{triggerFunc(() => { })}</span>
        </div>
        {!!value && <Services data={data} value={value.okazannieUslugiPolzovatelyamUchastik} />}
    </div>);
};
const SelectPartner = (props) => {
    const auth = useAuth()
    const { item, value, onChange, data } = props;
    const user = useSelector(state => state.home.user);

    const display = (object) => {
        if (!object) {
            return <span>Укажите {(value?.tipTDID === 1) ? "ассистента" : "партнера"}!</span>;
        }
        if (object) {
            return <span>{object.firstname + " " + object.lastname}</span>;
        }
        return <></>;
    };

    return (<div style={{ display: "flex", gap: "5px" }}>
        <div style={{ fontStyle: "italic" }}> - {(value?.tipTDID === 1) ? "ассистент" : "партнер"} - </div>
        <div>
            {display(value?.partner)}
        </div>
    </div>);
};
const Services = (props) => {
    const { auth, data, value } = props;
    const find = (data, i) => {
        let o = (data) ? data.find(e => e.ID === i.uslugaKlientuID) : undefined;;
        return o;
    };
    return (<div style={{ paddingTop: "3px", fontSize: "13px" }}>
        {(!!value) && JSXMap(value, (i, idx) => <div key={idx}>
            <div>
                <span>- {i.uslugaKlientu.yacheikaUsluga.nazvanie}</span>
                <SelectCategory auth={auth} value={i} />
                {(i?.tipTDID === 1 || i?.tipTDID === 2) && <div>
                    <SelectPartner
                        auth={auth}
                        item={find(data, i)}
                        value={i}
                        data={data}
                    />
                </div>}
            </div>
        </div>)}
    </div>);
};
const Male = (props) => {
    const { auth, item, index, value } = props;
    const gender = 1;
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            gender={gender}
            prefix={<MaleHeader />}
            item={item}
            index={index}
            value={value} />
    </div>);
};
const Female = (props) => {
    const { auth, item, index, value } = props;
    const gender = 2;
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            gender={gender}
            item={item}
            index={index}
            prefix={<FemaleHeader />}
            value={value} />
    </div>);
};
const Single = (props) => {
    const { auth, item, index, value } = props;
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            prefix={<SingleHeader />}
            item={item}
            index={index}
            value={value} />
    </div>);
};
const SingleByGender = (props) => {
    const { auth, item, index, value, onChange, onChangeSilent, usluga } = props;
    let genderID = value?.polzovatel?.genderID || value?.genderID;
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            prefix={(genderID == 1) ? <MaleHeader /> : (genderID == 2) ? <FemaleHeader /> : <Header icon="user-alt-3" title="" style={{ color: "cadetblue", fontSize: "13px" }} />}
            item={item}
            gender={genderID}
            index={index}
            value={value} />
    </div>);
};
const RenderCartItem = (props) => {
    const classes = useStyles();
    const { auth, item, index } = props;
    const description = (<div>
        {(!!item.uslugaNaMeropriyatii && !!item.uslugaNaMeropriyatii.opisanie) && <div style={{ fontSize: "13px" }}>{item.uslugaNaMeropriyatii.opisanie}</div>}
    </div>);
    const getPeopleByGender = (array, genderID) => {
        if (!array) return;
        for (let i = 0; i < array.length; i++) {
            const element = array[i];
            if ((element.polzovatel && element.polzovatel.genderID === genderID) ||
                (element.genderID && element.genderID === genderID) ||
                (element.polzovatelStrokoi)) {
                return element;
            }
        }
    };
    return (<>
        <div style={{ flex: "auto" }}>
            <List.Item.Meta
                className={classes.listMeta}
                title={item.uslugaNaMeropriyatii.nazvanie}
                description={description}
            />
            <div style={{ alignSelf: "flex-start", textAlign: "start" }}>
                <div style={{ padding: "5px 0px" }}>
                    {(item.uslugaNaMeropriyatii.vidUslugiID === 1) &&
                        <Male auth={auth} item={item} index={index}
                            value={getPeopleByGender(item.polzovateliVZakazeTovarVZakaze, 1)}
                        />
                    }
                    {(item.uslugaNaMeropriyatii.vidUslugiID === 2) &&
                        <Female auth={auth} item={item} index={index}
                            value={getPeopleByGender(item.polzovateliVZakazeTovarVZakaze, 2)}
                        />
                    }
                    {(item.uslugaNaMeropriyatii.vidUslugiID === 3) &&
                        <div style={{ display: "flex", justifyContent: "flex-start" }}>
                            <div>
                                <div style={{ paddingBottom: "5px" }}>
                                    <SingleByGender auth={auth} item={item} index={index}
                                        value={_.get(item, "polzovateliVZakazeTovarVZakaze[0]")} />
                                </div>
                                <div style={{ paddingBottom: "5px" }}>
                                    <SingleByGender auth={auth} item={item} index={index}
                                        value={_.get(item, "polzovateliVZakazeTovarVZakaze[1]")} />
                                </div>
                            </div>
                        </div>}
                    {(item.uslugaNaMeropriyatii.vidUslugiID === 4) &&
                        <Single auth={auth} item={item} index={index}
                            value={_.get(item, "polzovateliVZakazeTovarVZakaze[0]")}
                        />
                    }
                </div>
            </div>
            {(item?.uslugaNaMeropriyatii?.vklyuchitKommentarii == true) && <div style={{ maxWidth: "500px" }}>
                <div className='bg bg-transparent border-grey' style={{ fontSize: "12px", textAlign: "left", margin: "5px 0" }}>
                    <div style={{ fontSize: "11px", color: "rgba(0,0,0,.65)", display: "flex", justifyContent: "space-between" }}>
                        <div><i className="fa fa-comments-o"></i> Комментарий покупателя</div>
                        {/* <div><i className="fa fa-pencil-square-o"></i></div> */}
                    </div>
                    <div><Nl2Br text={item?.kommentarii} /></div>
                </div>
            </div>}
        </div>
        <div>
            <div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "16px" }}>
                <div style={(item.tsena !== item.tsenaDoPromokoda) ? { textDecoration: "line-through" } : {}}>{(item.tsenaDoPromokoda).toLocaleString()} руб.</div>
                {(item.tsena !== item.tsenaDoPromokoda) && <div style={{ color: "red" }}>{(item.tsena).toLocaleString()} руб.</div>}
            </div>
        </div>
    </>)
};
function CollectionList(props) {
    const classes = useStyles();
    const { auth, zakaz, loading } = props;

    return (
        <div>
            <List
                className={classes.itemsOrderUsluga}
                locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Нет абонементов" /> }}
                style={{ borderBottom: "1px solid #f0f0f0" }}
                itemLayout="horizontal"
                dataSource={(zakaz) ? zakaz.tovariVZakazeZakaz : []}
                loading={loading}
                renderItem={(item, index) => (
                    <List.Item>
                        <RenderCartItem auth={auth} uuid={uuid()} item={item} index={index} zakaz={zakaz} promo={zakaz.promokod} />
                    </List.Item>
                )}
            />
            {!loading && <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "500", fontSize: "16px", padding: "10px 0px 0px 0px" }}>
                <div>
                    ИТОГО:
                </div>
                {(zakaz && zakaz.obshchayaSumma) && <div>
                    {(zakaz.obshchayaSumma).toLocaleString()} руб.
                </div>}
            </div>}
        </div>
    );
}

function getCurrencyValue(value, color) {
    if (!value) {
        return (<span style={{ color: "grey" }}>
            0 руб.
        </span>)
    }
    if (color) {
        return (<span style={{ color: color }}>
            {(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
    if (value >= 0) {
        return (<span style={{ color: "rgb(63, 134, 0)" }}>
            {(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
    if (value < 0) {
        return (<span style={{ color: "red" }}>
            {(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
}

const orderStatusSumma = (item) => {
    let paymentStateID = 0
    let opisanie = ""
    if (item.ekvairingZakaz && item.ekvairingZakaz[0]) {
        paymentStateID = item.ekvairingZakaz[0].paymentStateID;
        opisanie = item.ekvairingZakaz[0].paymentState.opisanie
    }
    if (item.statusID == 2) { // Оплата возвращена
        return (
            <span style={{ color: "#7c7c7c" }}>
                Оплата возвращена
            </span>
        )
    } else if (item.statusID == 3 || item.statusID == 4) { // Оплачен
        return (
            <span style={{ color: "rgb(63, 134, 0)" }}>
                Оплачено
            </span>
        )
    } else if (item.statusID == 5) { // Ошибка оплаты
        return (
            <span style={{ color: "#ff4d4f" }}>
                Ошибка оплаты
            </span>
        )
    } else if (paymentStateID) { //Если есть объект эквайринга
        if (paymentStateID == 2) { // Новый
            return (
                <span style={{ color: "#eb8100" }}>
                    К оплате
                </span>)
        }
        if (paymentStateID == 3) { // В процессе оплаты
            return (
                <span style={{ color: "#0095ff" }}>
                    Оплата
                </span>
            )
        }
        if (paymentStateID == 4) { // Отменен
            return (
                <span style={{ color: "#ff4d4f" }}>
                    Отменен
                </span>
            )
        }
    } else {
        if (item.statusID == 1) { // Новый
            return (
                <span style={{ color: "#eb8100" }}>
                    К оплате
                </span>
            )
        }
    }
};

export default function ZakazAdminPreview(props) {

    const { auth, object, collectionActions, fedAdmin } = props;
    const [zakaz, setZakaz] = useState({});
    const [loading, setLoading] = useState(false);

    const { setCollectionItem } = collectionActions;

    // const ekvairingRevoke = React.useMemo(() => (ekvairingID) => {
    //     setLoading(true);
    //     GET(auth, `/ekvairing/pay-keeper/revoke/${ekvairingID}`,
    //         ({data}) => {
    //             let o = { ...zakaz, ekvairingZakaz: (data)?[data]:undefined}
    //             setCollectionItem(o);
    //             // update();
    //             setLoading(false);
    //         }, (err) => errorCatch(err, () => setLoading(false)));
    // }, [zakaz, collectionActions]);

    const ekvairingCheckstatusnotpaidekvairing = React.useMemo(() => (zakazID) => {
        setLoading(true);
        GET(auth, `/ekvairing/checkstatusnotpaidekvairing/${zakazID}`,
            ({ data }) => {
                let o = { ...zakaz, ekvairingZakaz: (data) ? [data] : undefined }
                setCollectionItem(o);
                // update();
                setLoading(false);
            }, (err) => errorCatch(err, () => setLoading(false)));
    }, [zakaz, collectionActions]);

    const ekvairingCheckstatusExpirednotpaidekvairing = React.useMemo(() => (zakazID) => {
        setLoading(true);
        GET(auth, `/ekvairing/checkstatusexpirednotpaidekvairing/${zakazID}`,
            ({ data }) => {
                let o = {
                    ...zakaz,
                    statusID: data?.zakaz?.statusID,
                    status: data?.zakaz?.status,
                    ekvairingZakaz: (data) ? [data] : undefined
                }
                setCollectionItem(o);
                // update();
                setLoading(false);
            }, (err) => errorCatch(err, () => setLoading(false)));
    }, [zakaz, collectionActions]);

    useEffect(() => {
        if (object) {
            setLoading(true);
            GET(auth, `/api/zakaz/bynomerandorganizator/${object.nomerZakaza}`, ({ data }) => {
                if (data) {
                    setZakaz(data);
                }
                setLoading(false);
            }, (err) => errorCatch(err, setLoading(false)))
        }
    }, [object]);
    const vozvrat = React.useMemo(() => (zakazID) => {
        GET(auth, `/api/zakaz/summa-vozvrata/${zakazID}`,
            ({ data }) => {

                Modal.confirm({
                    title: 'Выполнить возврат средств?',
                    icon: <ExclamationCircleOutlined />,
                    content: `Сумма в размере ${Number(data.toFixed(2)).toLocaleString('ru', { minimumFractionDigits: 2 })} руб. будет возвращена клиенту.`,
                    okText: "Да",
                    cancelText: "Нет",
                    onOk: () => {
                        setLoading(true);
                        GET(auth, `/api/zakaz/vozvrat/${zakazID}`,
                            ({ zakaz }) => {
                                setCollectionItem(zakaz);
                                // update();
                                setLoading(false);
                            }, (err) => errorCatch(err, () => setLoading(false)));
                    },
                });

                setLoading(false);
            }, (err) => errorCatch(err, () => setLoading(false)));

    }, [zakaz, collectionActions]);
    const [polniiVozvrat, setPolniiVozvrat] = useState(false);

    const buttons = (item, zakaz) => {
        if (item) {
            if (item.statusID == 3) {
                return ([
                    <div key="1" style={{ display: "flex", justifyContent: "end", gap: "5px", paddingBottom: "5px" }}>
                        <Action
                            auth={auth}
                            action={(values, unlock, close) => {
                                if (!zakaz) {
                                    unlock();
                                    return;
                                }
                                GET(auth, `/api/zakaz/vozvrat/${zakaz?.ID}?${(values?.polniiVozvrat) ? "polniiVozvrat=true" : ""}`,
                                    ({ zakaz }) => {
                                        setCollectionItem(zakaz);
                                        close();
                                    }, (err) => errorCatch(err, unlock));
                            }}
                            modal={{
                                width: "480px",
                                title: "Выполнить возврат средств?"
                            }}
                            okText="Вернуть"
                            mode={"func"}
                            zakaz={zakaz}
                            form={Vozvrat}
                            trigger={(click) => (
                                <Button onClick={click}>Возврат</Button>
                            )}
                        />

                    </div>
                ])
            }
        }

        let ekvairingZakaz = item?.ekvairingZakaz?.[0] || zakaz?.ekvairingZakaz?.[0];
        let meropriyatie = item?.meropriyatie || zakaz?.meropriyatie;
        if (ekvairingZakaz) {
            let paymentStateID = ekvairingZakaz.paymentStateID;
            if (paymentStateID == 2 || (paymentStateID == 3 && item.statusID == 1)) {
                return ([
                    <Button key="0" onClick={() => ekvairingCheckstatusnotpaidekvairing(item.ID)}>Обновить статус</Button>,
                    // <div key="1" style={{ display: "flex", justifyContent: "end", gap: "5px", paddingBottom: "5px" }}>
                    //     <Button key="2" onClick={() => pay(ekvairingZakaz.paymentUrl)}>Оплатить заказ</Button>
                    //     <Button key="3" onClick={() => ekvairingRevoke(ekvairingZakaz.ID)}>Отменить заказ</Button>
                    // </div>
                ])
            } 
            // else if (!!fedAdmin && meropriyatie?.tekushchiiStatusMeropriyatiyaID != 5 &&
            //     paymentStateID == 4 && (item.statusID == 1 || item.statusID == 5)) {
            //     return ([
            //         <Button key="0" onClick={() => ekvairingCheckstatusExpirednotpaidekvairing(item.ID)}>Обновить статус</Button>,
            //         // <div key="1" style={{ display: "flex", justifyContent: "end", gap: "5px", paddingBottom: "5px" }}>
            //         //     <Button key="2" onClick={() => pay(ekvairingZakaz.paymentUrl)}>Оплатить заказ</Button>
            //         //     <Button key="3" onClick={() => ekvairingRevoke(ekvairingZakaz.ID)}>Отменить заказ</Button>
            //         // </div>
            //     ])
            // }
        }
        return (<></>);
    };

    const items = useMemo(() => [
        {
            key: '1',
            label: 'Подробности оплаты',
            children: (
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                    {(zakaz.ekvairingZakaz && zakaz.ekvairingZakaz[0]) && <div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div style={{ fontWeight: "bold" }}>Эквайринг</div>
                            {(!!fedAdmin && zakaz?.meropriyatie?.tekushchiiStatusMeropriyatiyaID != 5 &&
                                zakaz.ekvairingZakaz[0]?.paymentStateID == 4 && (zakaz?.statusID == 1 || zakaz?.statusID == 5)) && <div>
                                    <Button key="0" danger onClick={() => ekvairingCheckstatusExpirednotpaidekvairing(zakaz?.ID)}>Проверить поступление оплаты</Button>
                                </div>}
                        </div>
                        <div style={{ fontWeight: "normal" }}>{zakaz.ekvairingZakaz[0]?.opisanie}</div>
                        <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0,0,0,0.65)" }}>
                            <div>Номер: {zakaz.ekvairingZakaz[0]?.nomer}</div>
                            <div>Дата: {dayjs(zakaz.ekvairingZakaz[0]?.UpdatedAt).format("DD.MM.YYYY HH:mm:ss")}</div>
                            <div>Статус: {zakaz.ekvairingZakaz[0]?.paymentState?.opisanie}</div>
                            <div>Сумма: {getCurrencyValue(zakaz.ekvairingZakaz[0]?.amount)}</div>
                            <div>Идентификатор: {zakaz.ekvairingZakaz[0]?.orderIdempotenceKey}</div>
                        </div>
                    </div>}

                    {(zakaz.oplatiZakaz && zakaz.oplatiZakaz[0]) && <div>
                        <div style={{ fontWeight: "bold" }}>Оплата</div>
                        <div style={{ fontWeight: "normal" }}>{zakaz.oplatiZakaz[0]?.opisanie}</div>
                        <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0,0,0,0.65)" }}>
                            <div>Дата: {dayjs(zakaz.oplatiZakaz[0]?.UpdatedAt).format("DD.MM.YYYY HH:mm:ss")}</div>
                            <div>Сумма: {getCurrencyValue(zakaz.oplatiZakaz[0]?.summa)}</div>
                        </div>
                    </div>}

                    {(zakaz.oplatiZakaz && zakaz.oplatiZakaz[0] && zakaz.oplatiZakaz[0].vozvratiOplata?.[0]) && <div>
                        <div style={{ fontWeight: "bold" }}>Возврат</div>
                        <div style={{ color: "red", fontWeight: "normal" }}>{zakaz.oplatiZakaz[0].vozvratiOplata[0]?.opisanie}</div>
                        <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0,0,0,0.65)" }}>
                            <div>Дата: {dayjs(zakaz.oplatiZakaz[0].vozvratiOplata[0]?.UpdatedAt).format("DD.MM.YYYY HH:mm:ss")}</div>
                            <div>Сумма: {getCurrencyValue(zakaz.oplatiZakaz[0].vozvratiOplata[0]?.summa, "red")}</div>
                            <div>Остаток: {getCurrencyValue(zakaz.oplatiZakaz[0].vozvratiOplata[0]?.summaOstatka, "grey")}</div>
                        </div>
                    </div>}

                </div>
            ),
        }
    ], [zakaz]);

    return (<>
        {(zakaz && zakaz.polzovatel) && <div>
            <div>Покупатель: {zakaz.polzovatel.lastname} {zakaz.polzovatel.firstname}</div>
            <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0,0,0,0.65)" }}>{zakaz.polzovatel.phone}, {zakaz.polzovatel.email}</div>
        </div>}
        <div>Статус: {orderStatusSumma(zakaz)}</div>
        {object?.promokod && <div>
            <div style={{ fontSize: "12px" }}>Промокод: <span style={{ fontWeight: "bold" }}>{object?.promokod}</span> {(object?.promokodSsilka?.opisanie) ? <span> ({object?.promokodSsilka?.opisanie})</span> : ""}</div>
        </div>}
        {/* {(object.ekvairingZakaz && object.ekvairingZakaz[0]) && <div>
            Оплата заказа №{object.ekvairingZakaz[0].nomer}
        </div>} */}
        <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: "5px", paddingTop: "15px" }}>
            {buttons(object, zakaz)}
        </div>
        {If(!!zakaz, <div className='zakaz-preview'>
            <CollectionList auth={auth} zakaz={zakaz} promo={zakaz.promokod} loading={loading} />

            {(!loading && fedAdmin) && <Collapse ghost items={items} />}

            {/* {!loading && <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {(zakaz.ekvairingZakaz && zakaz.ekvairingZakaz[0]) && <div>
                    <div style={{ fontWeight: "normal" }}>{zakaz.ekvairingZakaz[0]?.opisanie}</div>
                    <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0,0,0,0.65)" }}>
                        <div>Номер: {zakaz.ekvairingZakaz[0]?.nomer}</div>
                        <div>Дата: {dayjs(zakaz.ekvairingZakaz[0]?.UpdatedAt).format("DD.MM.YYYY HH:mm:ss")}</div>
                        <div>Статус: {zakaz.ekvairingZakaz[0]?.paymentState?.opisanie}</div>
                        <div>Сумма: {getCurrencyValue(zakaz.ekvairingZakaz[0]?.amount)}</div>
                        <div>Идентификатор: {zakaz.ekvairingZakaz[0]?.orderIdempotenceKey}</div>
                    </div>
                </div>}

                {(zakaz.oplatiZakaz && zakaz.oplatiZakaz[0]) && <div>
                    <div style={{ fontWeight: "normal" }}>{zakaz.oplatiZakaz[0]?.opisanie}</div>
                    <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0,0,0,0.65)" }}>
                        <div>Дата: {dayjs(zakaz.oplatiZakaz[0]?.UpdatedAt).format("DD.MM.YYYY HH:mm:ss")}</div>
                        <div>Сумма: {getCurrencyValue(zakaz.oplatiZakaz[0]?.summa)}</div>
                    </div>
                </div>}

                {(zakaz.oplatiZakaz && zakaz.oplatiZakaz[0] && zakaz.oplatiZakaz[0].vozvratiOplata?.[0]) && <div>
                    <div style={{ color: "red", fontWeight: "normal" }}>{zakaz.oplatiZakaz[0].vozvratiOplata[0]?.opisanie}</div>
                    <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0,0,0,0.65)" }}>
                        <div>Дата: {dayjs(zakaz.oplatiZakaz[0].vozvratiOplata[0]?.UpdatedAt).format("DD.MM.YYYY HH:mm:ss")}</div>
                        <div>Сумма: {getCurrencyValue(zakaz.oplatiZakaz[0].vozvratiOplata[0]?.summa, "red")}</div>
                        <div>Остаток: {getCurrencyValue(zakaz.oplatiZakaz[0].vozvratiOplata[0]?.summaOstatka, "grey")}</div>
                    </div>
                </div>}

            </div>} */}
        </div>)}
    </>);
}
// PaymentForm.whyDidYouRender = true
// CollectionList.whyDidYouRender = true
